<div class="container">
  <div class="row">
    <div class="col-md-12">
      <app-header [companyData]="companyData"></app-header>

      <div class="container p-0">
        <div class="row">
          <div class="col-md-12">
            <div [innerHTML]="formData"></div>
          </div>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
</div>
